import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import React from 'react'
import { SalesRedirectionButtonEntityInterface } from 'src/shared/entities/sales-redirection-button/sales-redirection-button-entity.schema'
import createCommonEntitySettings from '../createCommonEntitySettings'
import SalesRedirectionButtonSettings from './settings/SalesRedirectionButtonSettings'

function createSettingsForSales(
  entity: EntityInterface,
  defaultEntity?: EntityInterface,
) {
  switch (entity.type) {
    case EntityTypeEnum.SalesRedirectionButton:
      return (
        <SalesRedirectionButtonSettings
          entity={entity as SalesRedirectionButtonEntityInterface}
          defaultEntity={defaultEntity as SalesRedirectionButtonEntityInterface}
        />
      )
    default:
      return createCommonEntitySettings(entity, defaultEntity)
  }
}

export default createSettingsForSales
